import React from 'react'
import {RoomOfferVioTagDetails} from 'hooks/useRoomOfferVioTag'

import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {VioDealTag} from '@vio/shared/src/privateDeal/VioDealTag'

export const RoomOfferVioTag = ({
  roomOfferVioTagDetails,
  wrapper = children => children
}: {
  roomOfferVioTagDetails: RoomOfferVioTagDetails
  wrapper?: (children: React.ReactElement) => React.ReactElement
}) => {
  const {brandName} = useBrand()
  const {
    monetisation: {onlyOnBrandTag}
  } = useBrandCapabilities()

  const {
    currencyCode,
    isVioTagVisible,
    savingType,
    savingPrice,
    savingPercentage
  } = roomOfferVioTagDetails

  if (!isVioTagVisible || !onlyOnBrandTag.enabled) {
    return null
  }

  return wrapper(
    <VioDealTag
      savingPercentage={savingPercentage}
      message={{...onlyOnBrandTag.config.message, values: {brandName}}}
      savingType={savingType}
      savingPrice={savingPrice}
      currencyCode={currencyCode}
    />
  )
}
